import * as React from 'react';
import * as _ from 'lodash';
import { IPosition, IContact } from '@nkr/models/index';
import PositionListRow from './position-list-row';
import { plusSquare } from 'react-icons-kit/fa/plusSquare';
import { chevronRight } from 'react-icons-kit/fa/chevronRight';
import Icon from 'react-icons-kit';
import { TableWrapper } from './styles';

interface IProps {
    positions: IPosition[],
    staffList: IContact[],
    onOpenLogistics: (chainId: number, clusterNumer: number, positionNumber: number) => void
    onOpenOptions: (chainId: number, clusterNumer: number, positionNumber: number) => void
}

interface IState {
    expandedPositions: number[]
}

class PositionList extends React.Component<IProps, IState> {
    readonly state: IState = {
        expandedPositions: []
    }

    componentDidMount = () => { }

    handleExpandAllPositions = () => {
        let expandedPositions = this.props.positions.map(p => p.positionNumber - 1);

        this.setState({
            expandedPositions
        });
    }

    handleExpandPosition = (position: number) => {
        let expandedPositions = [...this.state.expandedPositions];

        if (expandedPositions.indexOf(position) >= 0) {
            expandedPositions = expandedPositions.filter(p => p != position);
        } else {
            expandedPositions.push(position);
        }

        this.setState({
            expandedPositions
        });
    }

    handleOpenLogistics = (chainId: number, clusterNumber: number, positionNumber: number) => {
        this.props.onOpenLogistics(chainId, clusterNumber, positionNumber);
    }

    handleOpenOptions = (chainId: number, clusterNumber: number, positionNumber: number) => {
        this.props.onOpenOptions(chainId, clusterNumber, positionNumber);
    }

    render = () => {
        const positions = _.orderBy(this.props.positions, (p) => { return p.positionNumber });

        return (
            <>
                <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th colSpan={4}></th>
                            <th colSpan={8} className='donor'>Donor</th>
                            <th colSpan={4} className='recipient'>Recipient</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>
                                <Icon
                                    icon={plusSquare}
                                    onClick={this.handleExpandAllPositions} />
                            </th>
                            <th>Pos</th>
                            <th title='Swap Manager'>S/M</th>
                            <th className='donor'>Donor<br />Center</th>
                            <th className='donor'>Donor<br />Alias</th>
                            <th className='donor'>Pickup<br />Date/Time</th>
                            <th className='donor'>Flight<br />Route or Ground</th>
                            <th className='donor'>Flight<br />Carrier &amp; Number</th>
                            <th className='donor'>Flight Departure<br />Date/Time</th>
                            <th className='donor'>Flight Arrival<br />Date/Time</th>
                            <th className='donor'>Estimated<br />Delivery Time</th>

                            <th className='recipient'>Recipient<br />Center</th>
                            <th className='recipient'>Recipient<br />Alias</th>
                            <th className='recipient'>Logistics<br />Provider</th>
                            <th className='recipient'>Logistics Provider<br />Job Number</th>
                        </tr>
                    </thead>
                    {positions.map((position, index) => {
                        const donorTimezone = position.donor.center.timezone;
                        const flightDepartureTimeBackupTz = position.donor.logistics.flightDepartureTimeBackupTz ? position.donor.logistics.flightDepartureTimeBackupTz : donorTimezone;
                        const flightDepartureTimeActualTz = position.donor.logistics.flightDepartureTimeActualTz ? position.donor.logistics.flightDepartureTimeActualTz : donorTimezone;

                        const recipientTimezone = position.recipient.center.timezone;
                        const flightArrivalTimeBackupTz = position.donor.logistics.flightArrivalTimeBackupTz ? position.donor.logistics.flightArrivalTimeBackupTz : recipientTimezone;
                        const flightArrivalTimeActualTz = position.donor.logistics.flightArrivalTimeActualTz ? position.donor.logistics.flightArrivalTimeActualTz : recipientTimezone;

                        return (
                            <tbody key={index} className='position-data'>
                                <PositionListRow
                                    key={index}
                                    index={index}
                                    position={position}
                                    staffList={this.props.staffList}
                                    isExpanded={this.state.expandedPositions.indexOf(index) >= 0}
                                    onExpand={this.handleExpandPosition}
                                    onOpenLogistics={this.handleOpenLogistics}
                                    onOpenOptions={this.handleOpenOptions}
                                />

                                {this.state.expandedPositions.indexOf(index) >= 0 && (
                                    <>
                                        <tr className='backup' onClick={() => this.handleOpenLogistics(position.chainId, position.clusterNumber, position.positionNumber)}>
                                            <td colSpan={5}></td>
                                            <td className='backup' style={{ textAlign: 'right', paddingRight: 10 }} colSpan={2}>Backup <Icon icon={chevronRight} size={8} /><Icon icon={chevronRight} size={8} /></td>
                                            <td className='backup'>{position.donor.logistics.kidneyPickupDateTimeBackup} {position.donor.logistics.kidneyPickupDateTimeBackup ? donorTimezone : ''}</td>
                                            <td className='backup'>{position.donor.logistics.flightRouteOrGroundBackup}</td>
                                            <td className='backup'>{position.donor.logistics.flightCarrierAndNumberBackup}</td>
                                            <td className='backup'>{position.donor.logistics.flightDepartureTimeBackup} {position.donor.logistics.flightDepartureTimeBackup ? flightDepartureTimeBackupTz : ''}</td>
                                            <td className='backup'>{position.donor.logistics.flightArrivalTimeBackup} {position.donor.logistics.flightArrivalTimeBackup ? flightArrivalTimeBackupTz : ''}</td>
                                            <td className='backup'>{position.donor.logistics.kidneyArrivalDateTimeBackup} {position.donor.logistics.kidneyArrivalDateTimeBackup ? recipientTimezone : ''}</td>
                                            <td className='backup' colSpan={4}></td>
                                        </tr>
                                        <tr className='actual' onClick={() => this.handleOpenLogistics(position.chainId, position.clusterNumber, position.positionNumber)}>
                                            <td colSpan={5}></td>
                                            <td className='actual' style={{ textAlign: 'right', paddingRight: 10 }} colSpan={2}>Actual <Icon icon={chevronRight} size={8} /><Icon icon={chevronRight} size={8} /></td>
                                            <td className='actual'>{position.donor.logistics.kidneyPickupDateTimeActual} {position.donor.logistics.kidneyPickupDateTimeActual ? donorTimezone : ''}</td>
                                            <td className='actual'>{position.donor.logistics.flightRouteOrGroundActual}</td>
                                            <td className='actual'>{position.donor.logistics.flightCarrierAndNumberActual}</td>
                                            <td className='actual'>{position.donor.logistics.flightDepartureTimeActual} {position.donor.logistics.flightDepartureTimeActual ? flightDepartureTimeActualTz : ''}</td>
                                            <td className='actual'>{position.donor.logistics.flightArrivalTimeActual} {position.donor.logistics.flightArrivalTimeActual ? flightArrivalTimeActualTz : ''}</td>
                                            <td className='actual'>{position.donor.logistics.kidneyArrivalDateTimeActual} {position.donor.logistics.kidneyArrivalDateTimeActual ? recipientTimezone : ''}</td>
                                            <td className='actual' colSpan={4}></td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        );
                    })}
                </TableWrapper>
            </>
        );
    }
}

export default PositionList;